import React from 'react';

import NationalContactsContent from './NationalContactsContent';
import NationalContactsTypeSelect from './NationalContactsTypeSelect';
import {
  CountrySelect,
  RegionalGroupSelect
} from '../Selects';

class NationalContacts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      country: null,
      group: null,
      type: null,
      totalCountries: props.totalCountries,
    };
  }

  onCountrySelect(country) {
    this.setState({
      country: country,
      group: null
    });
  }

  onGroupSelect(group) {
    this.setState({
      group: group,
      country: null
    });
  }

  onTypeSelect(type) {
    this.setState({
      type: type
    });
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-4">
            <CountrySelect
              value={ this.state.country }
              onSelect={ selected => this.onCountrySelect(selected.value) }
            />
          </div>
          <div className="col-sm-4">
            <RegionalGroupSelect
              className="country-select-list"
              value={ this.state.group }
              textForTotal="All States"
              onChange={ selected => this.onGroupSelect(selected.value) }
            />
          </div>
          <div className="col-sm-4">
            <NationalContactsTypeSelect
              value={ this.state.type }
              onSelect={ selected => this.onTypeSelect(selected.value) }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="reports-search-results">
              { this.state.country || this.state.group
                ? (
                  <NationalContactsContent
                    country={ this.state.country }
                    group={ this.state.group }
                    type={ this.state.type }
                  />
                ) : (
                  <small>Total countries which provided NationalContacts information {this.state.totalCountries}</small>
                )
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NationalContacts;



// WEBPACK FOOTER //
// ./src/components/NationalContacts/NationalContacts.js